module.exports = __webpack_public_path__ + "static/arboretum-beehive-research-366c4def1c20bd5efcb6cdaa9f32abf1.jpg";